import FreeForms from '@/views/free-forms/free-forms.vue'
import ShowFreeForm from '@/views/free-forms/free-forms-show.vue'
import AddFreeForm from '@/views/free-forms/free-forms-new.vue'
import { FreeFormsRouteNames } from '@/router/routes-names'

export const freeFormsRoutes = [
    {
        path: '/free-forms/',
        name: FreeFormsRouteNames.LIST,
        component: FreeForms,
        props: true
    },
    {
        path: '/free-forms/new',
        name: FreeFormsRouteNames.NEW,
        component: AddFreeForm
    },
    {
        path: '/free-forms/show/:formId',
        name: FreeFormsRouteNames.SHOW,
        component: ShowFreeForm
    }
]
